// extracted by mini-css-extract-plugin
module.exports = {"tfbDateTimePicker":"TFBDateTimePicker_tfbDateTimePicker__2HiQ8","dateLabel":"TFBDateTimePicker_dateLabel__2qi0F"};